export default function HomeStatsSection() {
  const stats = [
    {
      label: "累計認購金額",
      value: "NT$ 12,580,000",
      icon: "ri-funds-line",
      accent: "text-rose-700",
      bg: "bg-rose-50",
    },
    {
      label: "平台會員數",
      value: "8,420",
      icon: "ri-user-community-line",
      accent: "text-amber-600",
      bg: "bg-amber-50",
    },
    {
      label: "平均利潤",
      value: "NT$ 2,380",
      icon: "ri-arrow-up-line",
      accent: "text-emerald-600",
      bg: "bg-emerald-50",
    },
    {
      label: "上架貨源數",
      value: "156",
      icon: "ri-archive-line",
      accent: "text-sky-600",
      bg: "bg-sky-50",
    },
  ];

  return (
    <section className="w-full bg-stone-50 py-10 md:py-14 border-y border-stone-200">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="bg-white rounded-xl border border-stone-200 p-5 md:p-6"
            >
              <div
                className={`w-10 h-10 rounded-lg ${stat.bg} flex items-center justify-center mb-3`}
              >
                <i className={`${stat.icon} ${stat.accent} text-lg`} />
              </div>
              <p className="font-display text-xl md:text-2xl font-bold text-stone-800">
                {stat.value}
              </p>
              <p className="font-body text-xs text-stone-500 mt-1">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}